import { darken, getLuminance, lighten } from '@mui/material';

export const isSidebarBackgroundLight = (color: string): boolean => {
  if (color === 'transparent') return false;
  return getLuminance(color) > 0.33;
};

export const getSidebarHoverColor = (color: string): string => {
  if (color === 'transparent') return color;
  return isSidebarBackgroundLight(color)
    ? darken(color, 0.05)
    : lighten(color, 0.08);
};
